import Icon, { IconProps } from '../Icon';
const UndoIcon = (props: IconProps) => (
  <Icon viewBox="0 0 24 24" fill="currentColor" {...props}>
    <path d="M9.707 4.707a1 1 0 0 0-1.414-1.414l-5 5a1 1 0 0 0 0 1.414l5 5a1 1 0 0 0 1.414-1.414L6.414 10H14.5a4.501 4.501 0 0 1 1.722 8.657A4.501 4.501 0 0 1 14.5 19H11a1 1 0 1 0 0 2h3.5a6.499 6.499 0 1 0 0-13H6.414l3.293-3.293Z" />
  </Icon>
);
export default UndoIcon;
